<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Возвращает территорию по его идентификатору</p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code>curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' '{{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/presets/id_preset'</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      response: {
        status_code: 200,
        result: {
          data: [
            {
              id: "6004855201350efd131c1fe3",
              name: "test-area-a1",
              area: {
                points: [
                  {
                    x: 40.6612691406135,
                    y: 46.6793115911035
                  },
                  {
                    x: 40.4931853525463,
                    y: 46.681271850952
                  },
                  {
                    x: 40.4950975623092,
                    y: 46.750536709121
                  },
                  {
                    x: 40.5236663985488,
                    y: 46.7501598310838
                  },
                  {
                    x: 40.5257940773406,
                    y: 46.8254922779008
                  },
                  {
                    x: 40.4943019149233,
                    y: 46.8344796092236
                  },
                  {
                    x: 40.3897377350114,
                    y: 46.8361543232248
                  },
                  {
                    x: 40.3919834016061,
                    y: 46.9029148423116
                  },
                  {
                    x: 40.4910701042934,
                    y: 46.9245246923901
                  },
                  {
                    x: 40.4925833582102,
                    y: 46.9602200525156
                  },
                  {
                    x: 40.5927010646664,
                    y: 46.9588708611624
                  },
                  {
                    x: 40.5914023257483,
                    y: 46.8974586507632
                  },
                  {
                    x: 40.6856695558245,
                    y: 46.8961090820728
                  },
                  {
                    x: 40.6824401586406,
                    y: 46.8261536983488
                  },
                  {
                    x: 40.6657962327207,
                    y: 46.826397198051
                  },
                  {
                    x: 40.6612691406135,
                    y: 46.6793115911035
                  }
                ]
              },
              order_date: "2021-01-17T18:43:30.8517185Z",
              order_status: 3,
              order_progress: 100,
              up_time: "2021-01-17T18:43:30.8517185Z",
              status: 1
            }
          ],
          count: 1
        }
      }
    };
  }
};
</script>